import React from 'react';

interface ResultsListProps {
  words: string[];
  loading: boolean;
  error: string | null;
}

export const ResultsList: React.FC<ResultsListProps> = ({ words, loading, error }) => {
  if (error) {
    return (
      <div style={{
        padding: '16px',
        backgroundColor: 'rgba(220, 53, 69, 0.1)',
        border: '1px solid rgba(220, 53, 69, 0.3)',
        borderRadius: '8px',
        color: '#ff6b6b',
        fontSize: '14px',
        textAlign: 'center',
      }}>
        {error}
      </div>
    );
  }

  if (words.length === 0 && !loading) {
    return (
      <div style={{
        padding: '24px',
        textAlign: 'center',
        color: '#565758',
        fontSize: '14px',
      }}>
        Start typing to see suggestions
      </div>
    );
  }

  return (
    <div>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px',
      }}>
        <span style={{
          fontSize: '12px',
          fontWeight: 600,
          color: '#818384',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}>
          Suggestions
        </span>
        <span style={{
          fontSize: '12px',
          color: loading ? '#538d4e' : '#565758',
          transition: 'color 0.2s',
        }}>
          {loading ? '⟳ updating...' : `${words.length} words`}
        </span>
      </div>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px',
        maxHeight: '280px',
        overflowY: 'auto',
        padding: '12px',
        backgroundColor: '#1a1a1b',
        borderRadius: '8px',
        border: '1px solid #3a3a3c',
      }}>
        {words.map((word, index) => (
          <span
            key={index}
            style={{
              padding: '6px 10px',
              backgroundColor: '#272729',
              border: '1px solid #3a3a3c',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: 700,
              fontFamily: "'SF Mono', 'Fira Code', monospace",
              textTransform: 'uppercase',
              letterSpacing: '2px',
              color: '#d7dadc',
              transition: 'background-color 0.15s',
              cursor: 'default',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#538d4e';
              e.currentTarget.style.borderColor = '#538d4e';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#272729';
              e.currentTarget.style.borderColor = '#3a3a3c';
              e.currentTarget.style.color = '#d7dadc';
            }}
          >
            {word}
          </span>
        ))}
      </div>
    </div>
  );
};
